import * as React from 'react';
import ConfirmationModal from 'components/Common/confirmationModal';
import './deleteEligibilityRuleModal.scss';

interface DeleteRuleModalProps {
    isDeleting: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isProration?: boolean;
}

export class DeleteEligibilityRuleModal extends React.Component<DeleteRuleModalProps, {}> {
    constructor(props: DeleteRuleModalProps) {
        super(props);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
    }

    render(): React.ReactNode {
        const { isDeleting, isProration } = this.props;
        const title = isProration ? 'Delete Proration Rule' : 'Delete Eligibility Rule';

        return (
            <ConfirmationModal
                className="nomst-delete-eligibility-rule-modal"
                cancelMessage="Cancel"
                confirmMessage="Delete Rule"
                message={this.getMessage()}
                onCancel={this.handleCancelClick}
                onClose={this.handleCancelClick}
                onConfirm={this.handleConfirmClick}
                title={title}
                isProcessing={isDeleting}
                hideAttentionIcon={true}
            />
        );
    }

    private getMessage(): string {
        if (this.props.isProration) {
            return 'Any employees within this rule will no longer be prorated. ' +
                'Are you sure you would like to delete this rule?';
        }
        
        return 'Employees in this rule will become eligible for the budgets applied to this rule. ' +
            'Are you sure you would like to delete this rule?';
    }

    handleCancelClick(): void {
        this.props.onClose();
    }

    handleConfirmClick(): void {
        this.props.onConfirm();
    }
}

export default { DeleteEligibilityRuleModal };